import(/* webpackMode: "eager" */ "/vercel/path0/app/_home/_component/Banner.js");
import(/* webpackMode: "eager" */ "/vercel/path0/app/_home/_component/Product.js");
import(/* webpackMode: "eager" */ "/vercel/path0/app/_home/_component/ProductHits.js");
import(/* webpackMode: "eager" */ "/vercel/path0/app/_home/_component/ProductNew.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/atom/Container.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/atom/Footer.js");
import(/* webpackMode: "eager" */ "/vercel/path0/components/atom/Testimoni.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js")